import { Component, ViewChild } from '@angular/core';
import { Router } from "@angular/router";
import { BasePage } from "../../../shared/base.page";
import { ServiceCaller } from '../../../shared/services/ServiceCaller';
import { DxDataGridComponent, DxValidationGroupComponent } from 'devextreme-angular';
import { UIService } from '../../../shared/services/UIService';


@Component({
    templateUrl: './Interested.page.html',
})

export class CompaniesInterestedPage extends BasePage {

    @ViewChild("grid") grid: DxDataGridComponent;
    @ViewChild("frmInstall") frmInstall: DxValidationGroupComponent;
    //private mediumRegex = new RegExp("^(((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{8,})");

    items: any[] = [
        {
            title: "Install DB",
            name: "install",
            icon: "fa fa-cog",
            showOnRow: true
        },

        {
            title: "Export",
            name: "export",
            icon: "fa fa-file-excel-o ",
        }
    ]


    servers: any[];
    //countries: any[]=["AU","NZ"];
    dbSetups:any[];

    loadingVisible: boolean = false;
    popupVisible: boolean = false;
    //
    domain: string;
    server: string;
    country: string;
    dbSelectedId:string;
    isForTest: boolean = false;
    isSubcontractor:boolean=false;
    //



    constructor(public router: Router, api: ServiceCaller, public uiService: UIService) {
        super(api);
        this.loadingVisible = true;
        this.api.get("/Server/List").then(c => {
            this.servers = c;
        }).catch(() => {
        }).then(() => {
            this.loadingVisible = false;
        });

        this.api.get("/Company/SetupList", { isTest: this.isForTest,isSubContractor:this.isSubcontractor }).then(c => {
            this.dbSetups = c; 
        }).catch(() => {
        }).then(() => {
            this.loadingVisible = false;
        });
    }


    onMenuItemClick(e) {
        switch (e.name) {
            case "install":
                { 
                    let list = this.grid.instance.getSelectedRowKeys();
                    if (list.length) {
                        let data = this.grid.instance.getSelectedRowsData()[0];
                        if (data.Domain) {
                            this.uiService.error("This Company already has been installed.");
                            return;
                        }
                        this.isSubcontractor= data.IsSubContractor;
                        this.domain = data.Name.replace(/\s/g, "").substr(0, 10);
                        this.api.get("/Company/SetupList", { isTest: this.isForTest,isSubContractor:this.isSubcontractor }).then(c => {
                            this.dbSetups = c; 
                        })
                        this.popupVisible = true;
                    } 
                    break;
                }

            case "export":
                {
                    this.grid.instance.exportToExcel(false);
                    break;
                }

        }
    }


    install() {
        let list = this.grid.instance.getSelectedRowKeys();
        if (list.length) {
            let form = this.frmInstall.instance.validate();
            if (form.isValid) {
                let data: any = {
                    id: list[0],
                    Domain: this.domain,
                    IsTest: this.isForTest,
                    Server: this.server,
                    //Country: this.country,
                    DB_ID:this.dbSelectedId
                }
                this.loadingVisible = true;
                this.api.post("/Company/Install", data).then(c => {
                    this.popupVisible = false;
                    this.domain = "";
                    this.server = "";
                    this.country = "";
                    this.isForTest = false;
                    this.grid.instance.refresh();
                    this.frmInstall.instance.reset();
                }).catch(() => {
                }).then(() => {
                    this.loadingVisible = false;
                });
            }
        }
    }


    forTestChange(e)
    {
        this.api.get("/Company/SetupList", { isTest: this.isForTest,isSubContractor:this.isSubcontractor }).then(c => {
            this.dbSetups = c; 
            this.dbSelectedId=null;
        });
    }

}



// WEBPACK FOOTER //
// D:/Works/Safetyminder/Safetyminder/Admin/src/app/admin/pages/Companies/Interested.page.ts